import { createAlchemyWeb3 } from '@alch/alchemy-web3'
import { ApolloClient, gql, InMemoryCache } from '@apollo/client'
import { SafeEventEmitterProvider } from '@web3auth/base'
import axios from 'axios'
import { ethers } from 'ethers'
import { flow, groupBy, map, merge, spread } from 'lodash'
import moment from 'moment'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Web3 from 'web3'
import AlterBodyABI from './ABI/alterBodyABI.json'
import AlterOSABI from './ABI/alterOSABI.json'
import ABI from './ABI/chainLinkABI.json'
import ThreeDNftABI from './ABI/ThreeD_NFT.json'
import Data from './contractAddress.json'
import { IWalletProvider } from './walletProvider'

declare let window: any
const ethProvider = (provider: SafeEventEmitterProvider): IWalletProvider => {
  // Getting the Wallet account details of user
  const getAccounts = async () => {
    try {
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      // storing the wallet address in localstorage
      localStorage.setItem('WalletAddress', accounts[0])
      return accounts
    } catch (error) {
      console.error('Error', error)
    }
  }

  // Getting the Matic Balance of the user
  const getMaticBalance = async () => {
    try {
      const Provider = new ethers.providers.Web3Provider(provider)
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      const balance = await Provider.getBalance(accounts[0])
      // console.log(`balance: ${balance} ETH`)
      localStorage.setItem('WalletAddress', accounts[0])
      return balance
    } catch (error) {
      // getMaticBalance();
      console.error('Error occured', error)
    }
  }

  // Getting ERC20 token (MALT) Balance for the user

  const getMaltBalance = async () => {
    try {
      const contractAddress = Data.maltContractAddress
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      const polygonAPIKey = process.env.NEXT_PUBLIC_POLYGON_API_KEY
      const { data } = await axios.get(
        `https://api-testnet.polygonscan.com/api?module=account&action=tokenbalance&contractaddress=${contractAddress}&address=${accounts[0]}&tag=latest&apikey=${polygonAPIKey}`
      )
      // console.log("MALT BALANCE", data);
      return data
    } catch (error) {
      // console.log(error)
    }
  }

  const sendMaticTokens = async (to: any, value: any) => {
    try {
      // console.log("Sending...");
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      // converting value to string to avoid precison errors
      const amount = value.toString()

      const txRes = await web3.eth.sendTransaction({
        from: accounts[0],
        to: to,
        value: web3.utils.toWei(amount),
      })

      // console.log("Transaction Details...", txRes);
      return txRes
    } catch (error) {
      // console.log("error", error);
      return error
    }
  }

  // Getting past transactions happend on the wallet address

  const getTransactions = async (page: number, offset: number) => {
    try {
      console.log(page, offset)
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      const polygonApiKey = process.env.NEXT_PUBLIC_POLYGON_API_KEY
      const offsetLimit = offset || 10
      const pageNumber = page || 1
      const sortType = 'desc' // "desc" or "asc"
      const API_TYPE = 'api-testnet' // "api-testnet" or "api" TODO: change to "api" when using mainet

      // Getting Transactions Data
      const NormalTransactionsData = await axios.get(
        `https://${API_TYPE}.polygonscan.com/api?module=account&action=txlist&address=${accounts[0]}&startblock=0&endblock=99999999&page=${pageNumber}&offset=${offsetLimit}&sort=${sortType}&apikey=${polygonApiKey}`
      )
      const InternalTransactionsData = await axios.get(
        `https://${API_TYPE}.polygonscan.com/api?module=account&action=txlistinternal&address=${accounts[0]}&startblock=0&endblock=99999999&page=${pageNumber}&offset=${offsetLimit}&sort=${sortType}&apikey=${polygonApiKey}`
      )
      const ERC20_TransactionsData = await axios.get(
        `https://${API_TYPE}.polygonscan.com/api?module=account&action=tokentx&contractaddress=${Data.maltContractAddress}&address=${accounts[0]}&page=${pageNumber}&offset=${offsetLimit}&startblock=0&endblock=99999999&sort=${sortType}&apikey=${polygonApiKey}`
      )
      const ERC1155_LandNftTransactions = await axios.get(
        `https://${API_TYPE}.polygonscan.com/api?module=account&action=token1155tx&contractaddress=${Data.nftContractAddress}&address=${accounts[0]}&page=${pageNumber}&offset=${offsetLimit}&startblock=0&endblock=99999999&sort=${sortType}&apikey=${polygonApiKey}`
      )
      const ERC1155_3DNftTransactions = await axios.get(
        `https://${API_TYPE}.polygonscan.com/api?module=account&action=token1155tx&contractaddress=${Data.ThreeDNftContractAddress}&address=${accounts[0]}&page=${pageNumber}&offset=${offsetLimit}&startblock=0&endblock=99999999&sort=${sortType}&apikey=${polygonApiKey}`
      )
      // const ERC721_TransactionsData = await axios.get(
      //   `https://${API_TYPE}.polygonscan.com/api?module=account&action=tokennfttx&contractaddress=${}&address=${accounts[0]}&page=${page}&offset=${offsetLimit}&startblock=0&endblock=99999999&sort=${sortType}&apikey=${polygonApiKey}`
      // )

      // console.log('Normal Txns', NormalTransactionsData.data.result)
      // console.log('Internal Txns', InternalTransactionsData.data.result)
      // console.log('ERC20 Txns', ERC20TransactionsData.data.result)
      // console.log('1155_LandNft Txns', ERC1155_LandNftTransactions.data.result)
      // console.log('1155_3DNft Txns', ERC1155_3DNftTransactions.data.result)

      let concatenatedTransactions = NormalTransactionsData.data.result.concat(
        InternalTransactionsData.data.result,
        ERC1155_3DNftTransactions.data.result,
        ERC1155_LandNftTransactions.data.result,
        ERC20_TransactionsData.data.result
      )

      // Removing null or empty objects in data
      // IF rate limit reached remove the last rate limit warning line
      let TransactionData = concatenatedTransactions.filter(function (el: any) {
        return (
          el != null &&
          el.hash != undefined &&
          el?.from.toLowerCase() != el?.to.toLowerCase()
        )
      })

      // Merging Data to remove duplicates

      const TransactionList = flow(
        (arr) => groupBy(arr, 'hash'),
        (groups) => map(groups, spread(merge))
      )(TransactionData)

      console.log('Transactions_List', TransactionList)

      const All_Transactions = groupBy(TransactionList, (b) =>
        moment(b.timeStamp * 1000).format('MMMM YYYY')
      )

      console.log('All_Transactions Data', All_Transactions)

      const isOnlyReceived = (currentValue: any) =>
        currentValue.to.toLowerCase() === accounts[0].toLowerCase()

      let Received_Transactions: any = {}
      for (let receive in All_Transactions) {
        if (Object.prototype.hasOwnProperty.call(All_Transactions, receive)) {
          let items = All_Transactions[receive].filter(isOnlyReceived)
          if (items.length) {
            Received_Transactions[receive] = items
          }
        }
      }

      console.log('Received', Received_Transactions)

      const isOnlySent = (currentValue: any) =>
        currentValue.from.toLowerCase() === accounts[0].toLowerCase()

      let Sent_Transactions: any = {}

      for (let sent in All_Transactions) {
        if (Object.prototype.hasOwnProperty.call(All_Transactions, sent)) {
          let items = All_Transactions[sent].filter(isOnlySent)
          if (items.length) {
            Sent_Transactions[sent] = items
          }
        }
      }

      console.log('Sent_Transactions', Sent_Transactions)

      return [All_Transactions, Received_Transactions, Sent_Transactions]
    } catch (error) {
      console.error('Error', error)
    }
  }

  // TODO:
  // Change Contract Address
  const sendMaltTokens = async (to: any, value: any) => {
    try {
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      // Token contract address to be changed
      let contractAddress = Data.maltContractAddress
      let fromAddress = accounts[0]
      let toAddress = to
      // ABI to be changed
      const minABI: any[] = ABI.abi
      const amount = value.toString()
      // Get ERC20 Token contract instance
      let contract = new web3.eth.Contract(minABI, contractAddress)
      // calculate ERC20 token amount
      let totalAmount = web3.utils.toWei(amount)
      // Calling transfer function
      const txns = await contract.methods
        .transfer(toAddress, totalAmount)
        .send({ from: fromAddress })
        .on('transactionHash', function (hash: any) {
          // console.log(hash);
        })
      console.log('Transaction Details...', txns)
      return txns
    } catch (error) {
      // console.log(error);
    }
  }

  // getting NFT Tokens for the current user

  const getNFTTokens = async () => {
    const web3 = new Web3(provider as any)
    const accounts = await web3.eth.getAccounts()
    const alchemyApiKey = process.env.NEXT_PUBLIC_ALCHEMY_API_KEY
    const getNfts = createAlchemyWeb3(
      `https://polygon-mumbai.g.alchemy.com/v2/${alchemyApiKey}`
    )

    const nfts = await getNfts.alchemy.getNfts({
      owner: accounts[0],
    })
    console.log("owned NFT's,---", nfts)
    return nfts
  }

  const sendAsset = async (address: string, tokenid: any) => {
    try {
      // console.log(tokenid, "totalcount-", tokenid.length);
      const Provider = new ethers.providers.Web3Provider(provider)
      const signer = Provider.getSigner()
      const nftContract = new ethers.Contract(
        Data.nftContractAddress,
        AlterBodyABI.abi,
        signer
      )
      let fromAddress = await signer.getAddress()
      // console.log(fromAddress);
      let toAddress = address
      let tokenId = tokenid.map((x: string) => {
        return parseInt(x)
      })
      let amounts = tokenid.map(() => {
        return 1
      })
      console.log('amounts', amounts, 'token Ids', tokenId)
      let data = '0x00'
      let nftTx = await nftContract.safeBatchTransferFrom(
        fromAddress,
        toAddress,
        tokenId,
        amounts,
        data
      )
      console.log('Transferring asset....', nftTx.hash)
      let tx = await nftTx.wait()
      console.log('Asset Transferred!', tx)
    } catch (error) {
      console.log('Transfer error', error)
    }
  }

  const signMessage = async (emoji: string) => {
    const data = { error: '', isSuccess: false, data: '' }
    try {
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      const message = emoji
      // // console.log("message is", emoji)
      const sig = await web3.eth.personal.sign(message, accounts[0], '')
      // // console.log("signature", sig)
      // // console.log("Signature fetched")
      const recoveredSigner = web3.eth.accounts.recover(message, sig)
      // console.log(`${recoveredSigner} signed the message successfully`);
      data.isSuccess = true
      data.data = sig
      return sig
    } catch (error: any) {
      // toast(`User rejected signature`)
      data.error = error.message
      return error.message
    }
  }

  const metaMaskSign = async () => {
    try {
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()

      const header = {
        t: 'eip191',
      }

      const payload = {
        domain: window.location.host,
        uri: window.location.origin,
        address: accounts[0],
        statement: 'sign into the wallet',
        version: '1',
        chainId: '1',
      }

      const message = {
        header,
        payload,
        network: 'ethereum', // allowed values "solana", "ethereum", "starkware"
      }
      // console.log(message);

      const BackData = await axios.post(
        'https://auth-js-backend.tor.us/siww/get ',
        message
      )
      // console.log(BackData);

      const sign = await web3.eth.personal.sign(
        BackData.data.challenge,
        accounts[0],
        '',
        (err, result) => {
          if (err) {
            console.log(err)
          } else {
            console.log(result)
            return result
          }
        }
      )
      const signature = {
        t: 'eip191',
        s: sign,
      }

      const formData = {
        signature: signature,
        message: BackData?.data?.challenge,
      }

      let config = {
        method: 'post',
        url: 'https://auth-js-backend.tor.us/siww/verify',
        headers: {
          'Content-Type': 'application/json',
        },
        data: formData,
      }
      const JwtData = await axios(config)
      console.log(JwtData)
      const verifyData = {
        jwtToken: JwtData?.data?.token,
        address: accounts[0],
      }

      // console.log(verifyData);
      const GetVerifed = await axios.post(
        'https://us-central1-test-69192.cloudfunctions.net/app/getverified-externalWallet',
        verifyData
      )
      // console.log(GetVerifed);
      return GetVerifed
    } catch (error: any) {
      console.log(error)
    }
  }

  const signTransaction = async () => {
    try {
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      // console.log("pubKey", accounts);
      // only supported with social logins (openlogin adapter)
      const txRes = await web3.eth.signTransaction({
        from: accounts[0],
        gas: 21000,
        to: accounts[0],
        value: web3.utils.toWei('0.01'),
      })
      // console.log("txRes", txRes);
    } catch (error) {
      // console.log("error", error);
    }
  }
  function timeout(delay: any) {
    return new Promise((res) => setTimeout(res, delay))
  }

  const mint3DBody = async (
    isBiconomyInitialized: any,
    biconomyProvider: any,
    contractAlter: any,
    tokenuri: string,
    data: any,
    assetId: any
  ) => {
    try {
      if (parseInt(data)) {
        const web3 = new Web3(provider as any)
        const accounts = await web3.eth.getAccounts()

        let fromAddress = accounts[0]

        let tx = contractAlter.methods.mintBody(1, tokenuri, assetId).send({
          from: fromAddress,
          signatureType: biconomyProvider['EIP712_SIGN'],
        })

        tx.on('transactionHash', function () {})
          .once('confirmation', function (transactionHash: any) {
            timeout(5000)
            let totalsupply = contractAlter.methods
              .getTokenCirculations()
              .call()
            const tokenid = parseInt(totalsupply) + 1
            return tokenid
          })
          .on('error', function (e: any) {
            toast(`User rejected transaction`)
            return 0
          })
      } else {
        const Provider = new ethers.providers.Web3Provider(provider)
        const signer = Provider.getSigner()

        const nftContract = new ethers.Contract(
          Data.ThreeDNftContractAddress,
          ThreeDNftABI.abi,
          signer
        )

        let nftTx = await nftContract.mint3D(1, tokenuri, String(assetId), {
          value: ethers.utils.parseEther(String(0.0001)),
        })

        await nftTx.wait()

        let totalsupply = await nftContract.getTokenCirculations()
        timeout(5000)
        const tokenid = parseInt(totalsupply) + 1
        toast(`Mint Successful`)
        return tokenid
      }
    } catch (error: any) {
      let errmsg = 'Mint Failed..!'
      if (error && error.code && error.code === 4001) {
        errmsg = 'Transaction Rejected'
      } else if (error && error.data && error.data.code) {
        if (error.data.code === -32000) {
          errmsg = 'Insufficient balance'
        }
      }

      toast(errmsg)
      return 0
    }
  }

  const mintAlterBody = async (
    isBiconomyInitialized: any,
    biconomyProvider: any,
    contractAlter: any,
    tokenuri: string,
    data: any,
    assetId: any
  ) => {
    // console.log("In mintalterbody before try block")
    // return 5;
    try {
      if (parseInt(data)) {
        const web3 = new Web3(provider as any)
        const accounts = await web3.eth.getAccounts()

        let fromAddress = accounts[0]

        let tx = contractAlter.methods.mintBody(1, tokenuri, 1, assetId).send({
          from: fromAddress,
          signatureType: biconomyProvider['EIP712_SIGN'],
        })

        tx.on('transactionHash', function () {})
          .once('confirmation', function (transactionHash: any) {
            timeout(5000)
            let totalsupply = contractAlter.methods
              .getTokenCirculations()
              .call()
            const tokenid = parseInt(totalsupply) + 1
            return tokenid
          })
          .on('error', function (e: any) {
            console.log('e', e)
            toast(`User rejected transaction`)
            return 0
          })
      } else {
        const Provider = new ethers.providers.Web3Provider(provider)
        const signer = Provider.getSigner()

        const nftContract = new ethers.Contract(
          Data.nftContractAddress,
          AlterBodyABI.abi,
          signer
        )

        let nftTx = await nftContract.mintBody(1, tokenuri, assetId, {
          value: ethers.utils.parseEther(String(0.0001)),
        })

        await nftTx.wait()

        let totalsupply = await nftContract.getTokenCirculations()
        timeout(5000)
        const tokenid = parseInt(totalsupply) + 1

        toast(`Mint Successful`)
        return tokenid
      }
    } catch (error: any) {
      let errmsg = 'Mint Failed..!'

      if (error && error.code && error.code === 4001) {
        errmsg = 'Transaction Rejected'
      } else if (error && error.data && error.data.code) {
        console.log('inside IF', error.data)
        if (error.data.code === -32000) {
          errmsg = 'Insufficient balance'
        }
      }

      toast(errmsg)
      return 0
    }
  }

  // Listing NFT for Sale
  const listForSale = async (
    isErc721: boolean, // boolean
    nftAddress: string, // address string
    tokenIds: number[], // token id comes from metadata
    price: any, // int from userf
    seller: string, // user owns nft from address wallet
    amount: number, // 1
    erc20Address: string,
    assetId: any,
    currentCategory: string
  ) => {
    console.log(
      'dev',
      isErc721,
      nftAddress,
      tokenIds,
      price,
      seller,
      amount,
      erc20Address,
      assetId,
      currentCategory
    )
    try {
      const Provider = new ethers.providers.Web3Provider(provider)
      const signer = Provider.getSigner()
      const marketContract = new ethers.Contract(
        Data.marketplaceContractAddress,
        AlterOSABI.abi,
        signer
      )
      let nftContract

      if (currentCategory === 'AlterBody' || currentCategory === 'avatar') {
        nftContract = new ethers.Contract(
          Data.nftContractAddress,
          AlterBodyABI.abi,
          signer
        )
        nftAddress = Data.nftContractAddress
      } else {
        nftContract = new ethers.Contract(
          Data.ThreeDNftContractAddress,
          ThreeDNftABI.abi,
          signer
        )
        nftAddress = Data.ThreeDNftContractAddress
      }

      seller = await signer.getAddress()
      price = ethers.utils.parseEther(String(price))

      let approve = await ApproveCheck(currentCategory)
      if (!approve) {
        await ApproveNFT(currentCategory)
      }

      let nftTx = await marketContract.createListing(
        isErc721, // boolean
        nftAddress, // address string
        tokenIds, // token id comes from metadata
        price, // int from user // user owns nft from address wallet
        amount, // 1
        erc20Address,
        String(assetId),
        []
      )

      await nftTx.wait()

      // console.log("Listed for sale!", tx);
      toast(`Asset Listed Successfully`)
      timeout(5000)
      return 1
    } catch (error: any) {
      let errmsg = 'Listing Failed..!'

      if (error && error.code && error.code === 4001) {
        errmsg = 'Transaction Rejected'
      } else if (error && error.data && error.data.message) {
        if (error.data.code === -32000) {
          errmsg = 'Insufficient balance'
        }
      }
      toast(errmsg)
      return 0
    }
  }

  const getGasFee = async () => {
    try {
      console.log('get gas fee method inside ether provider')
      const Provider = new ethers.providers.Web3Provider(provider)
      const signer = Provider.getSigner()

      const nftContract = new ethers.Contract(
        Data.nftContractAddress,
        AlterBodyABI.abi,
        signer
      )

      // for mint body pass actual parameters which we are going to use
      const gasConsumed = await nftContract.estimateGas.mintBody(
        1, //use actual value
        'tokenuri', //use actual value
        'assetId', //use actual value
        {
          value: ethers.utils.parseEther(String(0.0001)),
        }
      )

      const gasPrice = await Provider.getGasPrice()
      const transactionFee = gasPrice.mul(gasConsumed.toNumber())

      console.log(
        'Show this one as gas fee or transacton fee',
        ethers.utils.formatUnits(transactionFee, 'ether')
      )
      console.log(
        'ether>>',
        parseFloat(ethers.utils.formatUnits(transactionFee, 'ether')).toFixed(6)
      )
      return parseFloat(
        ethers.utils.formatUnits(transactionFee, 'ether')
      ).toFixed(6)
    } catch (error) {
      console.log('get gas fee error', error)
    }
  }

  // Buy Listed NFT for Sale
  const buyNFT = async (
    listingId: any,
    erc20Address: any,
    assetId: any,
    price: any
  ) => {
    try {
      const Provider = new ethers.providers.Web3Provider(provider)
      const signer = Provider.getSigner()
      const Contract = new ethers.Contract(
        Data.marketplaceContractAddress,
        AlterOSABI.abi,
        signer
      )

      let amount = price.toString()
      const web3 = new Web3(provider as any)
      let nftTx = await Contract.buyAssetFromListing(
        listingId,
        erc20Address,
        String(assetId),
        {
          value: web3.utils.toWei(amount),
        }
      )
      await nftTx.wait()
      toast('NFT bought successfully')
      timeout(10000)
      return 'Successful'
    } catch (error: any) {
      let errmsg
      if (error.message.split('(')[0] === 'Internal JSON-RPC error.') {
        errmsg = 'Not enough funds for the transaction'
      } else {
        errmsg = error.message.split('(')[0]
      }
      // let errmsg = "Unable to proceed with the tranaction"
      let errordata
      try {
        errordata = error.message.split('reverted:')[1]
          ? error.message.split('reverted:')[1].split('"')[0]
          : error.data.message.split(':')[1]
      } catch (error) {
        errordata = 'User rejected transaction'
      }
      toast(errordata)
      return errordata
    }
  }

  const updateNFTListing = async (listingId: any, assetId: any, price: any) => {
    try {
      const Provider = new ethers.providers.Web3Provider(provider)
      const signer = Provider.getSigner()
      const Contract = new ethers.Contract(
        Data.marketplaceContractAddress,
        AlterOSABI.abi,
        signer
      )
      let newPrice = ethers.utils.parseEther(price.toString())

      let nftTx = await Contract.updateListingPrice(
        parseInt(listingId),
        newPrice,
        assetId.toString()
      )
      await nftTx.wait()
      return true
    } catch (error: any) {
      let errmsg = 'Updating price failed..!'

      if (error && error.code && error.code === 4001) {
        errmsg = 'Transaction Rejected'
      } else if (error && error.data && error.data.message) {
        if (error.data.code === -32000) {
          errmsg = 'Insufficient balance'
        }
      }
      toast(errmsg)
      return false
    }
  }

  // Cancel Listed NFT in marketplace
  const cancelNFTListing = async (listingId: any, assetId: any) => {
    try {
      const Provider = new ethers.providers.Web3Provider(provider)
      const signer = Provider.getSigner()
      const Contract = new ethers.Contract(
        Data.marketplaceContractAddress,
        AlterOSABI.abi,
        signer
      )

      let nftTx = await Contract.cancelListing(
        parseInt(listingId),
        assetId.toString()
      )
      await nftTx.wait()
      return true
    } catch (error: any) {
      let errmsg = 'Removing from listing failed..!'

      if (error && error.code && error.code === 4001) {
        errmsg = 'Transaction Rejected'
      } else if (error && error.data && error.data.message) {
        if (error.data.code === -32000) {
          errmsg = 'Insufficient balance'
        }
      }

      toast(errmsg)
      return false
    }
  }

  // NFT Access Approval check
  const ApproveCheck = async (currentCategory: any) => {
    try {
      const Provider = new ethers.providers.Web3Provider(provider)
      const signer = Provider.getSigner()

      let nftContract
      if (currentCategory === 'AlterBody' || currentCategory === 'avatar') {
        nftContract = new ethers.Contract(
          Data.nftContractAddress,
          AlterBodyABI.abi,
          signer
        )
      } else {
        nftContract = new ethers.Contract(
          Data.ThreeDNftContractAddress,
          ThreeDNftABI.abi,
          signer
        )
      }

      let fromAddress = signer.getAddress()

      let isApproved = await nftContract.isApprovedForAll(
        fromAddress,
        Data.marketplaceContractAddress
      )
      return isApproved
    } catch (error) {
      // console.log(error);
    }
  }

  // Set NFT Access Approval
  const ApproveNFT = async (currentCategory: any) => {
    try {
      const Provider = new ethers.providers.Web3Provider(provider)
      const signer = Provider.getSigner()
      // console.log("Data.nftContractAddress", Data.nftContractAddress)
      // console.log("signer", signer)
      let nftContract
      if (currentCategory === 'AlterBody' || currentCategory === 'avatar') {
        nftContract = new ethers.Contract(
          Data.nftContractAddress,
          AlterBodyABI.abi,
          signer
        )
      } else {
        nftContract = new ethers.Contract(
          Data.ThreeDNftContractAddress,
          ThreeDNftABI.abi,
          signer
        )
      }

      let setApproval = await nftContract.setApprovalForAll(
        Data.marketplaceContractAddress,
        true
      )
      await setApproval.wait()
    } catch (error) {
      console.log(error)
    }
  }
  // Get Marketplace listed item IDs check
  const getOpenListing = async () => {
    try {
      const web3 = new Web3(provider as any)

      // Alter OS contract address
      let contractAddress = Data.marketplaceContractAddress

      const alterOSABI: any[] = AlterOSABI.abi

      let contract = new web3.eth.Contract(alterOSABI, contractAddress)

      let idsList = await contract.methods.getOpenListings().call()
      return idsList
    } catch (error) {
      // console.log(error);
    }
  }

  const getPrivateKey = async () => {
    return
  }
  // Check for available free mints
  const getNoOfFreeMints = async () => {
    try {
      const web3 = new Web3(provider as any)
      const accounts = await web3.eth.getAccounts()
      // To address should be dynamic
      let fromAddress = accounts[0]
      // Alter Body contract address
      let contractAddress = Data.nftContractAddress

      const alterBodyABI: any[] = AlterBodyABI.abi

      let contract = new web3.eth.Contract(alterBodyABI, contractAddress)

      let freeMints = await contract.methods
        .CheckFreeMintsAvailablePerWallet(fromAddress)
        .call()
      // console.log("freeMints", freeMints);
      return freeMints
    } catch (error) {
      console.log('free', error)
    }
  }

  const getMarketplaceFee = async (): any => {
    try {
      const Provider = new ethers.providers.Web3Provider(provider)

      const contract = new ethers.Contract(
        Data.marketplaceContractAddress,
        AlterOSABI.abi,
        Provider
      )

      const marketFeeBigInt = await contract.getMarketplaceFeePercentage()
      const marketRoyalty = await contract.getRoyalyPercentage()

      const fee = parseInt(ethers.utils.formatEther(String(marketFeeBigInt)))

      const royalty = parseInt(ethers.utils.formatEther(String(marketRoyalty)))
      return { fee, royalty }
    } catch (e) {
      console.log(e)
    }
  }

  const getListingId = async (assetId: string) => {
    const APIURL =
      'https://api.thegraph.com/subgraphs/name/diksha-leaguex/alter-os'
    const client = new ApolloClient({
      uri: APIURL,
      cache: new InMemoryCache(),
    })
    const query = `query {
      listingCreateds(where:{assetId:"wkg0mJB3jFIM7QRdLMU4"}) {
        listingId
      }
    }`
    try {
      let res = await client.query({
        query: gql(query),
      })

      console.log('Listing Id :', res.data.listingCreateds[0].listingId)
      return parseInt(res.data.listingCreateds[0].listingId)
    } catch (error) {
      console.error(error)
    }
  }

  return {
    getAccounts,
    getMaticBalance,
    signMessage,
    getNFTTokens,
    getMaltBalance,
    sendMaltTokens,
    sendMaticTokens,
    signTransaction,
    getTransactions,
    mintAlterBody,
    mint3DBody,
    sendAsset,
    getMarketplaceFee,
    getGasFee,
    listForSale,
    buyNFT,
    getListingId,
    cancelNFTListing,
    updateNFTListing,
    ApproveCheck,
    getOpenListing,
    ApproveNFT,
    metaMaskSign,
    getNoOfFreeMints,
    getPrivateKey,
  }
}

export default ethProvider
